var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn",attrs:{"role":"button","selected":_vm.state},on:{"click":_vm.change}},[_c('div',[_c('img',{staticStyle:{"width":"15px"},attrs:{"src":_vm.state?require('../assets/images/device/power_e.png'):require('../assets/images/device/power.png')}}),_c('button',{domProps:{"textContent":_vm._s(_vm.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }